import { render, staticRenderFns } from "./ButtonFooter.vue?vue&type=template&id=6bba213b&scoped=true&"
import script from "./ButtonFooter.vue?vue&type=script&lang=js&"
export * from "./ButtonFooter.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFooter.vue?vue&type=style&index=0&id=6bba213b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba213b",
  null
  
)

export default component.exports